import { render, staticRenderFns } from "./shopLogin.vue?vue&type=template&id=1004f69f&scoped=true"
import script from "./shopLogin.vue?vue&type=script&lang=js"
export * from "./shopLogin.vue?vue&type=script&lang=js"
import style0 from "./shopLogin.vue?vue&type=style&index=0&id=1004f69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004f69f",
  null
  
)

export default component.exports